// extracted by mini-css-extract-plugin
export default {"listContainer":"lists_listContainer__eJWOZ","listDiv":"lists_listDiv__v0XzI","delIcon":"lists_delIcon__YvX95"};